import StyleGrid from "./layout/style-grid";
import StyleGrid2 from "./layout/style-grid2";

function RenderView(props) {
	const {
		col_style,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,
		slider_options,
		data,
	} = props;

	const sliderSettings = {
		slidesPerView: parseInt(col_xl) ? parseInt(col_xl) : 3,
		slidesPerGroup: parseInt(col_xl) ? parseInt(col_xl) : 3,
		spaceBetween: parseInt(slider_options["spaceBetween"]),
		speed: parseInt(slider_options["autoPlaySlideSpeed"]),
		loop: Boolean(slider_options["loop"]),
		autoHeight: Boolean(slider_options["autoHeight"]),


		// Responsive breakpoints
		breakpoints: {
			0: {
				slidesPerView: parseInt(col_mobile) ? parseInt(col_mobile) : 1,
				slidesPerGroup: parseInt(col_mobile) ? parseInt(col_mobile) : 1
			},
			575: {
				slidesPerView: parseInt(col_sm) ? parseInt(col_sm) : 2,
				slidesPerGroup: parseInt(col_sm) ? parseInt(col_sm) : 2
			},
			767: {
				slidesPerView: parseInt(col_md) ? parseInt(col_md) : 2,
				slidesPerGroup: parseInt(col_md) ? parseInt(col_md) : 2
			},
			991: {
				slidesPerView: parseInt(col_lg) ? parseInt(col_lg) : 3,
				slidesPerGroup: parseInt(col_lg) ? parseInt(col_lg) : 3
			},
			1199: {
				slidesPerView: parseInt(col_xl) ? parseInt(col_xl) : 3,
				slidesPerGroup: parseInt(col_xl) ? parseInt(col_xl) : 3
			}
		}
	}

	if (slider_options.arrowNavigation) {
		sliderSettings.navigation = {
			nextEl: '.rtcl-gb-slider-btn.button-right',
			prevEl: '.rtcl-gb-slider-btn.button-left',
		};
	}

	if (slider_options.dotNavigation) {
		sliderSettings.pagination = {
			el: '.rtcl-gb-slider-pagination',
			type: 'bullets',
			clickable: true
		};
	} else {
		sliderSettings.pagination = false;
	}

	if (slider_options.autoPlay) {
		sliderSettings.autoplay = {
			delay: parseInt(slider_options.autoPlayDelay),
			pauseOnMouseEnter: Boolean(slider_options.stopOnHover),
			disableOnInteraction: false
		};
	}

	return (
		<>
			{col_style["style"] == '1' && <StyleGrid {...props} data={data} sliderSettings={sliderSettings} />}
			{col_style["style"] == '2' && <StyleGrid2 {...props} data={data} sliderSettings={sliderSettings} />}
		</>
	)
}

export default RenderView;